import React from 'react';

const BellIcon = ({
  className = 'w-6 h-6 text-gray-600 hover:text-gray-800 cursor-pointer',
  notificationCount = 0,
  ...props
}) => {
  return (
    <div className="relative">
      <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" {...props}>
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M10 20.3A2.3 2.3 0 0 0 12.3 18h-.6A2.3 2.3 0 0 0 10 20.3zm8-10.8A6 6 0 0 0 6 9.5v3l-1.5 1.5v1h15v-1L18 12.5z"
        />
      </svg>
      {notificationCount > 0 && (
        <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full w-4 h-4 flex items-center justify-center">
          {notificationCount}
        </span>
      )}
    </div>
  );
};

export default BellIcon;
